"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var attending_1 = require("../../model/attending");
var auto_eletric_service_1 = require("../../../shared/service/auto-eletric.service");
var technician_1 = require("../../../shared/model/technician");
var technician_service_1 = require("../../../shared/service/technician.service");
var scheduling_1 = require("../../model/scheduling");
var moment = require("moment");
var datePickerOptions = require("../../../core/date-picker-options");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var SchedulingComponent = /** @class */ (function () {
    function SchedulingComponent(_autoEletricService, _technicianService, _authService, _toastService) {
        this._autoEletricService = _autoEletricService;
        this._technicianService = _technicianService;
        this._authService = _authService;
        this._toastService = _toastService;
        this._attending = new attending_1.Attending();
        this.txOnSave = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.autoEletricAttributesTree = ['name'];
        this.autoEletricsResultLimit = 3;
        this.datePickerFormat = datePickerOptions.minDatePicker;
        this.timePickerFormat = datePickerOptions.timePicker;
        this.schedulingDateActions = new core_1.EventEmitter();
        this.schedulingTimeActions = new core_1.EventEmitter();
        this.datePickerIsOpen = false;
        this.timePickerIsOpen = false;
        this.SCHEDULING = 'SCHEDULING';
        this.autoEletricChoosedOnScheduling = false;
        this.suggestedByArgos = null;
    }
    SchedulingComponent.prototype.ngOnInit = function () {
        this.setEmptyEntities();
        this.setUpObservers();
    };
    SchedulingComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    Object.defineProperty(SchedulingComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.setEmptyEntities();
            this.findArgosAutoEletrics();
            if (this._attending.attendingInfo.autoEletric) {
                this.findTechnicians(this._attending.attendingInfo.autoEletric);
            }
            this.showStep();
        },
        enumerable: true,
        configurable: true
    });
    SchedulingComponent.prototype.save = function () {
        if (this.validateScheduleDate()) {
            if (this.autoEletricId != null && this.autoEletricChoosedOnScheduling) {
                if (this.suggestedByArgos == null) {
                    this.suggestedByArgos = true;
                }
                var associateAutoEletric = { 'attendingInfoId': this.attending.attendingInfo.id, 'autoEletricId': this.autoEletricId,
                    'autoEletricStep': 'SCHEDULING', 'suggestedByArgos': this.suggestedByArgos };
                this.attending.scheduling.associateAutoeletric = associateAutoEletric;
            }
            this.attending.scheduling.scheduleDate = moment(this.date + " " + this.time, 'DD/MM/YYYY HH:mm');
            this.txOnSave.emit(this.attending);
        }
        else {
            this.showMessage('Informe a data e a hora do atendimento!');
        }
    };
    SchedulingComponent.prototype.cancel = function () {
        this.txOnCancel.emit();
    };
    SchedulingComponent.prototype.findAutoEletric = function (name) {
        if (this.canEdit()) {
            this._autoEletricService.findByName(name);
        }
    };
    SchedulingComponent.prototype.findArgosAutoEletrics = function () {
        var _this = this;
        if (this.attending.screening.providedServices.length > 0 && this.canEdit()) {
            this._autoEletricService
                .findBests(this.getSearchParams())
                .subscribe(function (autoEletrics) { return _this.argosAutoEletrics = autoEletrics; }, function (error) { return _this.showMessage(error.text); });
        }
    };
    SchedulingComponent.prototype.selectAutoEletric = function (autoEletric) {
        if (this.autoEletricId === autoEletric.id) {
            this.attending.attendingInfo.autoEletric = null;
            this.autoEletricId = null;
            this.suggestedByArgos = null;
        }
        else {
            this.attending.attendingInfo.autoEletric = autoEletric;
            this.autoEletricId = autoEletric.id;
            this.suggestedByArgos = false;
            this.autoEletricChoosedOnScheduling = true;
            this.findTechnicians(autoEletric);
        }
    };
    SchedulingComponent.prototype.selectAutoEletricSuggestedByArgos = function (autoEletric) {
        if (this.autoEletricId === autoEletric.id) {
            this.attending.attendingInfo.autoEletric = null;
            this.autoEletricId = null;
            this.suggestedByArgos = null;
        }
        else {
            this.attending.attendingInfo.autoEletric = autoEletric;
            this.autoEletricId = autoEletric.id;
            this.suggestedByArgos = true;
            this.autoEletricChoosedOnScheduling = true;
            this.findTechnicians(autoEletric);
        }
    };
    SchedulingComponent.prototype.setTechnician = function (technician) {
        this.attending.scheduling.technician = technician;
        this.attending.scheduling.technicianContact = this.attending.scheduling.technician.phone;
    };
    SchedulingComponent.prototype.toggleDatePicker = function () {
        this.schedulingDateActions.emit({ action: 'pickadate', params: ['open'] });
    };
    SchedulingComponent.prototype.toggleTimePicker = function () {
        this.schedulingTimeActions.emit({ action: 'pickatime', params: ['show'] });
    };
    SchedulingComponent.prototype.getFormatedDate = function () {
        if (this.attending.scheduling.scheduleDate) {
            var scheduleDate = new Date(this.attending.scheduling.scheduleDate);
            return moment(scheduleDate).format('DD/MM/YYYY HH:mm');
        }
    };
    SchedulingComponent.prototype.canEdit = function () {
        return (this.attending.scheduling.canEdit || this.attending.scheduling.canEdit === undefined) && this.editable;
    };
    SchedulingComponent.prototype.canView = function () {
        return this.attending.scheduling.canView && !this.canEdit();
    };
    SchedulingComponent.prototype.canViewComponent = function (types) {
        return types.includes(this.attending.type);
    };
    SchedulingComponent.prototype.getSearchParams = function () {
        return {
            providedServices: this.attending.screening.providedServices,
            branchId: this.attending.branch ? this.attending.branch.id : null,
            equipmentModelId: this.attending.screening.equipmentModel ? this.attending.screening.equipmentModel.id : null,
            resultLimit: this.autoEletricsResultLimit,
            accessoryMovementLogs: this.attending.accessoryMovementLogs
        };
    };
    SchedulingComponent.prototype.validateScheduleDate = function () {
        return this.date && this.time;
    };
    SchedulingComponent.prototype.showStep = function () {
        if (this.attending.orderedSteps && this.attending.currentStep === this.SCHEDULING) {
            this.setIsVisible();
            this.setIsEditable();
        }
    };
    SchedulingComponent.prototype.setIsVisible = function () {
        var _this = this;
        if (this.attending.orderedSteps.includes(this.SCHEDULING)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === _this.SCHEDULING; })) {
            this.attending.scheduling.canView = true;
        }
        else {
            this.attending.dispatch.canView = false;
        }
    };
    SchedulingComponent.prototype.setIsEditable = function () {
        var _this = this;
        if (this.authenticatedUser.stepKeys.find(function (view) { return view.stepType === _this.SCHEDULING; })) {
            this.attending.scheduling.canEdit = true;
        }
        else {
            this.attending.scheduling.canEdit = false;
        }
    };
    SchedulingComponent.prototype.findTechnicians = function (autoEletric) {
        var _this = this;
        if (this.canEdit()) {
            this._technicianService
                .findByProvidedServicesAndAutoEletricId(this.attending.screening.providedServices, autoEletric.id)
                .subscribe(function (technicians) { return _this.technicians = technicians; }, function (error) { return _this.showMessage(error.text); });
        }
    };
    SchedulingComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    SchedulingComponent.prototype.setEmptyEntities = function () {
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
        if (!this.attending.scheduling) {
            this.attending.scheduling = new scheduling_1.Scheduling();
        }
        if (!this.attending.scheduling.technician) {
            this.attending.scheduling.technician = new technician_1.Technician();
        }
        if (this.canEdit() && this.attending.scheduling.scheduleDate && !this.time) {
            var date = new Date(this.attending.scheduling.scheduleDate);
            this.date = moment(date).format('DD/MM/YYYY');
            this.time = moment(date).format('HH:mm');
        }
        if (this.attending.attendingInfo.autoEletric) {
            this.autoEletricId = this.attending.attendingInfo.autoEletric.id;
            this.autoEletricChoosedOnScheduling = false;
        }
    };
    SchedulingComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._autoEletricService.find$
            .filter(function (result) { return result instanceof Array; })
            .subscribe(function (autoEletrics) { return _this.userAutoEletrics = autoEletrics; });
    };
    SchedulingComponent.ctorParameters = function () { return [{ type: auto_eletric_service_1.AutoEletricService }, { type: technician_service_1.TechnicianService }, { type: authentication_service_1.AuthenticationService }, { type: toast_service_1.ToastService }]; };
    return SchedulingComponent;
}());
exports.SchedulingComponent = SchedulingComponent;
//# sourceMappingURL=scheduling.component.js.map


// WEBPACK FOOTER //
// scheduling.component.js